import React, { useEffect, useRef, useState } from "react";
import DetailsInput from "./DetailsInput";
import { useAtom } from "jotai";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";
import { useNavigate } from "react-router-dom";
import { useUpdateItem } from "../../_helper/actions/mutation/items";
import { toast } from "react-toastify";
import moment from "moment";
import { useCurrentRole } from "../../_helper/constant/Permission";
import { useCreateItem } from "../../_helper/actions/mutation/items";

const UserCreateRoles = ({ mode, id }) => {
  const [rolesData, setRolesData] = useState();
  const initialFormData = {
    login: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    profile_img: "",
    employee_number: "",
    department: "",
    active: false,
    inactive: false,
    password: "",
    confirm_password: "",
  };

  // const patchRoles = useUpdateItem(ApiEndPoint?.USERS);

  const postUsers = useCreateItem(ApiEndPoint?.USERS, ApiEndPoint?.CLINIC);

  const patchDoctorDetails = useUpdateItem(
    `${ApiEndPoint?.USERS}doctor_personal_detail/`,
    ApiEndPoint?.CLINIC
  );

  const [roleId, setRolesId] = useState();

  const [formData, setFormData] = useState(initialFormData);

  const [clinic] = useAtom(clinicAtom);

  const { role_id } = useCurrentRole();

  const [checkedFeatures, setCheckedFeatures] = useState([]);

  // const { mode, id, users } = useParams();

  // const location = useLocation();
  // const params = new URLSearchParams(location.search);
  // const mode2 = params?.get("mode");

  // const modes = mode?.split("=")[1];
  // const user = users?.split("=")[1];

  const getClinicStaffquery = `?action=getClinicStaff&backend=True&clinic_id=${clinic?.id}&id=${id}`;

  const { data: getClinicStaffData, isLoading: getClinicStaffLoading } =
    useItemsFilter(
      ApiEndPoint?.CLINIC,
      getClinicStaffquery,
      clinic?.id && id ? true : false
    );

  useEffect(() => {
    if (getClinicStaffData) {
      const {
        last_login,
        doctor_personal_details,
        user_role,
        id: user_id,
      } = getClinicStaffData;

      const istLastLogin = moment
        .utc(last_login)
        .utcOffset("+05:30")
        .format("YYYY-MM-DD hh:mm:ss A");

      const fData = {
        ...doctor_personal_details,
        istLastLogin,
      };

      const features = user_role;
      setCheckedFeatures(features);

      setRolesId(user_role[0]?.id);
      setFormData(fData);
      setImagePreview(fData.profile_img);

      //(fData, 'getClinicStaffData');
    }
  }, [getClinicStaffData]);

  const [imagePreview, setImagePreview] = useState("");

  // Reference for file input element
  const fileInputRef = useRef();

  const navigate = useNavigate();

  const query = `?action=getRoles&clinic_id=${clinic?.id}&frontend=True&admin_roles=True`;

  const { data, isLoading } = useItemsFilter(
    ApiEndPoint?.USERS,
    query,
    clinic?.id ? true : false
  );

  useEffect(() => {
    if (data) {
      setRolesData(data);
    }
  }, [data]);

  const handleInputChange = (e, field) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  function checkMatchingIds(id, checkedFeatures, rolesData) {
    const checkedFeaturesIds = checkedFeatures?.map((item) => item?.id);
    const rolesDataIds = rolesData?.map((item) => item?.id);
    return checkedFeaturesIds?.includes(id) && rolesDataIds?.includes(id);
  }

  const handleFeatureCheckboxChange = (ele) => {
    const isChecked = checkedFeatures.some((item) => item.id === ele.id);

    if (isChecked) return;
    setCheckedFeatures([ele]);
  };

  const handleSave = (formData) => {
    // const isValidEmail = (email) => {
    //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //   return emailRegex.test(email);
    // };

    // const isValidPhoneNumber = (phone) => {
    //   return phone?.length == 10;
    // };

    if (
      getClinicStaffData?.user_role?.length > 0 &&
      getClinicStaffData?.user_role[0]?.is_admin
    ) {
      toast.error("You cannot edit the admin role");
      return;
    }

    const isValidName = (name) => {
      const nameRegex = /^[a-zA-Z\s]+$/;
      return name && nameRegex.test(name);
    };

    const isValidEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    const isFormDataValid = (data, mode) => {
      if (!isValidName(data.first_name)) {
        toast.error(
          "First name is required and should contain only alphabets."
        );
        return false;
      }
      if (!isValidName(data.last_name)) {
        toast.error("Last name is required and should contain only alphabets.");
        return false;
      }
      if (!isValidEmail(data.email)) {
        toast.error("Invalid email format.");
        return false;
      }
      if (data.phone_number.length !== 10) {
        toast.error("Phone number should be exactly 10 digits.");
        return false;
      }
      if (!data.status) {
        toast.error("Status is required.");
        return false;
      }
      if (!data.employee_number) {
        toast.error("Employee number is required.");
        return false;
      }
      if (!data.department) {
        toast.error("Department is required.");
        return false;
      }

      if (data.password !== data.confirm_password) {
        toast.error("Password and Confirm Password did not match");
        return false;
      }
      return true;
    };

    if (!isFormDataValid(formData, mode)) {
      return;
    }

    if (!formData?.id && mode === "create") {
      const postpayload = {
        first_name: formData?.first_name,
        last_name: formData?.last_name,
        clinic_id: clinic?.id,
        backend: "True",
        action: "postReceptionistDoct",
        email: `${formData?.phone_number}@cufront.com`,
        is_internal: false,
        mobile: formData?.phone_number,
        register_by_walkin: false,
        linked_clinics: [clinic?.id],
        linked_doctors: [role_id],
        user_role: [checkedFeatures[0]?.id],
        is_staff: true,
        is_superuser: false,
        is_active: formData?.status,
        is_clinic_admin: false,
        password1: formData.password,
        password2: formData.password,
        doctor_personal_details: {
          email: formData?.email,
          highest_qualification: "ssc",
          hospital_address: "empty",
          medical_registration_number: "empty",
          state: "empty",
          graduation_year: "20",
          first_name: formData?.first_name,
          last_name: formData?.last_name,
          phone_number: formData?.phone_number,
          employee_number: formData?.employee_number,
          department: formData?.department,
        },
      };

      postUsers.mutate(postpayload, {
        onSuccess: () => {
          toast.success("Successfully create the user");
          navigate(-1);
        },
        onError: (err) => {
          toast.error(err.response.data.message);
        },
      });
    } else {
      const patchDoctorDetailsPayload = {
        action: "patchDoctorPersonalDetails",
        backend: "True",
        id: formData?.id,
        clinic_id: clinic?.id,
        email: formData?.email,
        profile_img: formData?.profile_img,
        first_name: formData?.first_name,
        last_name: formData?.last_name,
        status: formData?.status,
        department: formData?.department,
        employee_number: formData?.employee_number,
        phone_number: formData?.phone_number,
        gender: formData?.gender,
        roles_id: [checkedFeatures[0]?.id],
        user_id: id,
      };

      patchDoctorDetails.mutate(
        {
          data: patchDoctorDetailsPayload,
        },

        {
          onSuccess: () => {
            toast.success("Successfully updated the doctor details");
            navigate(-1);
          },
          onError: (err) => {
            toast.error(err.response.data.message);
          },
        }
      );
    }
  };

  return (
    <div className="cu-setup-options-main gap-[25px] large:gap-[35px]">
      {/* <div className="cu-setup-options-menu">
        <h3>{"Users"}</h3>
      </div> */}

      <div className="flex">
        <div className="w-1/3">
          {/* <h3>
            User Details{" "}
            {mode === "view" && <span className="text-sm">(View Only)</span>}
          </h3> */}
          <div>
            <DetailsInput
              fileInputRef={fileInputRef}
              imagePreview={imagePreview}
              setImagePreview={setImagePreview}
              userDetails={true}
              formData={formData}
              setFormData={setFormData}
              handleUserInputChange={handleInputChange}
              readOnly={mode === "view"}
              save={handleSave}
              mode={mode}
              isLoading={patchDoctorDetails?.isLoading || postUsers?.isLoading}
            />
          </div>
        </div>

        <div className="flex-1 ml-20">
          <h3>Role</h3>
          <div>
            {rolesData?.map((ele, ind) => (
              <div className="flex gap-2">
                <div className="">
                  <div className="inline-flex">
                    <label
                      className="relative flex items-center p-0.5 rounded-full cursor-pointer"
                      htmlFor="check"
                    >
                      <input
                        type="checkbox"
                        className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-[#C7EAC9] checked:bg-[#C7EAC9] checked:before:bg-[#C7EAC9] hover:before:opacity-10"
                        id="check"
                        disabled={mode === "view"}
                        checked={checkMatchingIds(
                          ele?.id,
                          checkedFeatures,
                          rolesData
                        )}
                        onChange={() => handleFeatureCheckboxChange(ele)}
                      />
                      <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-3.5 w-3.5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          stroke="currentColor"
                          stroke-width="1"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      </span>
                    </label>
                  </div>
                </div>

                <div className="flex gap-2">
                  <p
                    onClick={() =>
                      navigate(
                        `/new/setup/clinicsetup/12/rolesAndPermission/mode=view/id=${ele?.id}`
                      )
                    }
                    className="text-[#17A1FA] cursor-pointer text-base"
                  >
                    {ele?.name}
                  </p>
                  <p className="text-base text-[#999999]">{ele?.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {isLoading && <CuScreenLoader />}
    </div>
  );
};

export default UserCreateRoles;
